



































































































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import Combobox from '../../core/components/Combobox.vue';
import { MsgBox, PlusEyeButtons, Breadcrums, CloseConfirmationModal } from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';

@Component({
    components: {
        multiselect,
        Loading,
        Combobox,
        PlusEyeButtons,
        Breadcrums,
        CloseConfirmationModal,
        DeleteConfirmation
    }
})
export default class ModalJoinRanchs extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({
        default() {
            return [];
        }
    })
    ranchsIds: string[];
    @Prop({
        default() {
            return [];
        }
    })
    cropTypeOptions: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    selectedRanchs: Array<object>;
    @Prop() visible: boolean;
    @Prop({default: false}) isSowing: boolean;
    visibleModalJoinRanchs: boolean = false;
    pendingRequest: boolean = false;
    description: string = '';
    modalTitle: string = 'Unir Chacras';
    confirmationDelete: boolean = false;
    loadingIgnoredPeriods: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';

    //select options
    cropTypeSelected: any | null = null;

    //select reset value
    cropTypeRV: boolean = false;

    msgLoadingDialog: string = '';
    errorResponse: any = {};
    successPost: boolean | null = null;
    forceDeslinkRanches: boolean = false;

     showDeleteConfirmationDialog(title, msgBody) {
        this.deleteModalTitle = title;
        this.deleteBody = msgBody;
        this.confirmationDelete = true;
    }
    
    showAlertLinkedRanchs() {
        this.showDeleteConfirmationDialog(
            'Chacras con vínculos existentes',
            'Hay chacras seleccionadas que están vinculadas con otras chacras.<b>Al unirlas se perderán éstos vínculos.<br> ¿Está seguro que desea unirlas?' 
        );
    }
    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;
            this.forceDeslinkRanches = true;
            this.joinRanchs();
        } else {
            this.confirmationDelete = false;
        }
    }

    //methods
    mounted() {
        this.handleListenKey(true);
        this.visibleModalJoinRanchs = this.visible;
        this.forceDeslinkRanches = false;
    }

    matchedIndexInArray(arr, id) {
        let optionIndex = arr.findIndex(item => item['id'] == id);
        return optionIndex;
    }

    updatecropTypeSelected(option) {
        this.cropTypeSelected = option;
    }

    updateCropTypeResetValue(value) {
        this.cropTypeRV = value;
    }

    closeModal() {
        this.$emit('close-modal', false);
        this.handleListenKey(false);
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    checkIfExistLinkedRanchsInSelectedRanchs(){
        let indexLinkedRanch = -1;
        if(this.isSowing){
           indexLinkedRanch = this.selectedRanchs.findIndex(item => item['harvest_ranch_link'] !== null)
        }else{
            indexLinkedRanch = this.selectedRanchs.findIndex(
                item => item['properties']['sowing_ranch_link'] !== null
            )
        }
        if(indexLinkedRanch !== -1){
            this.showAlertLinkedRanchs();
        }else{
            this.joinRanchs();
        }
    }

    joinRanchs() {
        let self = this;
        this.pendingRequest = true;
        let configuration = this.getData();
        this.showLoadingDialog('Uniendo Chacras...');
        InsuranceServices.sowingJoinRanchs(configuration)
            .then(response => {
                let msg = '';
                if (response && response.message) {
                    msg = response.message;
                } else {
                    msg = 'Chacras Unidas con éxito';
                }
                self.pendingRequest = false;
                self.showSuccessLoadingDialog(response, msg);
                self.$emit('update-farming-detail');
            })
            .catch(err => {
                self.pendingRequest = false;
                self.showCatchLoadingDialog(err, 'No se pudieron unir las chacras');
            });
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }

    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg,
            timeout:8000
        });
        this.closeModal();
    }

    getData() {
        return {
            ranch_ids: this.ranchsIds,
            name: this.description,
            harvest_type: this.cropTypeSelected == null ? null : Number(this.cropTypeSelected['id']),
            force_deslink_ranches: this.forceDeslinkRanches
        };
    }

    get checkIfFormIsValid() {
        if (this.description === '') {
            return false;
        }

        return true;
    }

    enableScrollLoadingDialog() {
        $('.dialog-slot').css('overflow-y', 'auto');
        $('html').css('overflow-y', 'auto');
    }

    closeModalLoadingDialog() {
        this.pendingRequest = false;
        this.successPost = null;
        this.msgLoadingDialog = '';
        this.enableScrollLoadingDialog();
    }

    getFinalizationValue(finalization) {
        if (finalization !== null) {
            if (finalization['id'] !== -1) {
                return finalization['id'];
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    getInitializationValue(initialization) {
        if (initialization !== null) {
            if (initialization['id'] !== -1) {
                return initialization;
            } else {
                return null;
            }
        } else {
            return null;
        }
    }
}
